<template>
    <v-bottom-sheet v-model="dialog" v-if="bottom" v-bind="dialogProps">
        <v-card tile>
            <component :is="component" v-bind="props" v-on="listeners" />
        </v-card>
    </v-bottom-sheet>
    <v-dialog v-model="dialog" v-else v-bind="dialogProps" :width="dialogWidth">
        <v-card tile>
            <component :is="component" v-bind="props" v-on="listeners" />
        </v-card>
    </v-dialog>
</template>

<script>
    import SgAskDialog from './SgAskDialog'

    export default {
        watch: {
            dialog(newVal) {
                if (!newVal) {
                    this.component = null,
                        this.props = null,
                        this.dialogProps = null,
                        this.listeners = null
                }
            }
        },
        computed: {
            dialogWidth() {
                return this.isMobile ? '80%' : 'unset'
            }
        },
        data() {
            return {
                component: null,
                props: null,
                dialogProps: null,
                dialog: false,
                bottom: false,
                listeners: null
            }
        },
        methods: {
            onHashChange() {
                if (location.hash == '') {
                    this.dialog = false
                }
            }
        },
        created() {


            this.$eventBus.$on('modal:dialog', data => {

                if (data.hashMode === true) {
                    location.hash = '#dialog'
                }

                this.component = SgAskDialog
                this.listeners = data.listeners
                this.dialogProps = data.dialogProps
                this.props = data.props
                this.bottom = (data.bottom === true)
                this.dialog = true
            })

            this.$eventBus.$on('modal:open', data => {

                /*           location.hash = '#dialog' */

                if (data.hashMode === true) {
                    location.hash = '#dialog'
                }

                this.component = data.component
                this.listeners = data.listeners
                this.dialogProps = data.dialogProps
                this.props = data.props
                this.bottom = (data.bottom === true)
                this.dialog = true
            })

            this.$eventBus.$on('modal:close', data => {

                if (location.hash == '#dialog') {

                    this.$router.back()
                } else {
                    this.dialog = false
                }


            })

            window.addEventListener('hashchange', this.onHashChange, false);
        },
        beforeDestroy() {
            window.removeEventListener('hashchange', this.onHashChange, false);
        }
    }
</script>

<style>

</style>